import axios, { AxiosRequestConfig } from "axios";
import { Message, MessageBox } from "element-ui";
import { UserModule } from "@/store/modules/user";
import { OmsResponse } from "@/utils/omsResponse";
function filterParams(params) {
  const result = {} as any;
  for (const key in params) {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      result[key] = params[key];
    }
  }
  return result;
}
axios.defaults.paramsSerializer = function (params) {
  const filteredParams = filterParams(params);
  let queryString = '';
  for (const key in filteredParams) {
    const value = filteredParams[key];
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(value);
    queryString += `${encodedKey}=${encodedValue}&`;
  }
  return queryString.slice(0, -1);
};
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + "/hq-oms", // url = base url + request url
  timeout: 120000,
  // withCredentials: true // send cookies when cross-domain requests
});

// Request interceptors
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (UserModule.token && config && config.headers) {
      config.headers["X-Access-Token"] = UserModule.token;
      config.headers["Authorization"] = UserModule.token;
    }
    return config;
  },
  (error: ErrorEvent) => {
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  (response: OmsResponse) => {
    const status = response.status;
    if (status === 200) {
      const data = response.data;
      if (data == undefined || data.code == undefined) {
        return response;
      }

      if (data.code === 0) {
        return data.data || data;
      }
      Message({
        message: data.message || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(data.message || "Error"));
    } else {
      Message({
        message: response.data.message || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(response.data.message || "Error"));
    }
  },
  (error: any) => {
    const message =
      error.response?.data?.message ||
      error.response?.data ||
      (error.code === "ECONNABORTED" ? "请求超时" : error.message) ||
      "网络错误";
    Message({
      message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
